export default "__VITE_ASSET__DokDRzAL__"